module.exports = __webpack_public_path__ + "static/media/galdisa_blog_blog_header.f5e53f9c.jpg";